// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list-no-data[data-v-ab519e3c]{position:relative;padding-top:19px;text-align:center;margin-top:20px}.list-no-data__icon[data-v-ab519e3c]{position:relative;margin:0 auto;width:150px;height:180px;background:url(https://i.gsxcdn.com/2118937032_h9c1xnpo.png) no-repeat;background-size:100%;background-repeat:no-repeat}.list-no-data__text[data-v-ab519e3c]{color:#717274;font-size:16px;height:22px;line-height:22px;margin:-10px auto}", ""]);
// Exports
module.exports = exports;
